module.exports = __webpack_public_path__ + "img/pouce_off.c74ce4b5.gif";